@if (productDetails$ | async; as product) {
  <!-- discontinued product tag -->
  @if (isProductDiscontinuedInRegion) {
    <p class="product-discontinued alert-danger">
      <span class="mr-2"
        ><i class="fa-solid fa-ban pr-2"></i
        ><span>{{ 'shared.discontinuedProduct.discontinuedTag' | cxTranslate }}</span></span
        >@if (product.replacementProduct) {
        <span class="message">{{
          'shared.discontinuedProduct.infoMessage' | cxTranslate
        }}</span>
      }
    </p>
  }
  <div class="code">{{ 'productSummary.articleNumber' | cxTranslate }} {{ product?.code }}</div>
}
